"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function setTooltipPosition(tooltipEl, parameters) {
    if (!tooltipEl)
        return;
    requestAnimationFrame(() => {
        const parentElXBound = Math.floor(tooltipEl.parentElement
            ? tooltipEl.parentElement.getBoundingClientRect().x
            : 0);
        const parentContainerElXBound = Math.floor(tooltipEl.parentElement && tooltipEl.parentElement.parentElement
            ? tooltipEl.parentElement.parentElement.getBoundingClientRect().x
            : 0);
        const parentContainerElWidth = Math.floor(tooltipEl.parentElement && tooltipEl.parentElement.parentElement
            ? tooltipEl.parentElement.parentElement.getBoundingClientRect().width
            : 0);
        const tooltipWidth = Math.floor(tooltipEl === null || tooltipEl === void 0 ? void 0 : tooltipEl.getBoundingClientRect().width) || 0;
        const tooltipLeftBound = parentElXBound - parentContainerElXBound - tooltipWidth / 2;
        const tooltipRightBound = parentContainerElXBound +
            parentContainerElWidth -
            (parentElXBound + parameters.tooltipTargetObjectWidth) -
            tooltipWidth / 2;
        // NOTE: If there is no enough space to render the tooltip from the left side, then we should move it to the right.
        if (tooltipLeftBound <= 0) {
            tooltipEl.style.left = `${parentContainerElXBound - parentElXBound}px`;
            return;
        }
        // NOTE: If there is no enough space to render the tooltip from the right side, then we should move it to the left.
        if (tooltipRightBound < 0) {
            tooltipEl.style.left = '';
            tooltipEl.style.right = `${parentElXBound +
                parameters.tooltipTargetObjectWidth -
                (parentContainerElXBound + parentContainerElWidth)}px`;
            return;
        }
        // NOTE: If there is enough space both from the left and right side, then just position the tooltip at the middle of
        // the target object.
        tooltipEl.style.right = '';
        tooltipEl.style.left = `${(parameters.tooltipTargetObjectHalfWidth - tooltipWidth) / 2}px`;
    });
}
exports.default = setTooltipPosition;
//# sourceMappingURL=setTooltipPosition.js.map